export function parseCourtNumber(court: string | number | null | undefined): string {
  if (court === null || court === undefined || court === '') return '';
  const match = court.toString().match(/\d+/);
  return match ? match[0] : court.toString();
}
